import { PriceObjectDto } from "@modules/common/priceObject/gateway/priceObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { currencySymbol, formatCurrency } from "@modules/currency/currency"
import { useLanguage } from "@modules/language/hooks/useLanguage"
import { HUText } from "@modules/ui/components/huText"
import { HUFontStyle } from "@modules/ui/styles/font"

type CurrencyFormattedPriceProps = {
  price?: PriceObjectDto
  wholePartFontStyle?: HUFontStyle
  decimalPartFontStyle?: HUFontStyle
} & React.HTMLAttributes<HTMLDivElement>

export const CurrencyFormattedPrice = ({
  price,
  wholePartFontStyle,
  decimalPartFontStyle,
  ...props
}: CurrencyFormattedPriceProps) => {
  const language = useLanguage()
  if (!price) return <HUText fontStyle="HS">{word("programBundle.form.pricing.free")}</HUText>
  const symbol = currencySymbol(price.currency, language)
  const formattedPrice = formatCurrency(price.value, price.currency, language).replace(symbol, "")
  const [wholePart, decimalPart] = formattedPrice.split(",")

  return (
    <div style={{ whiteSpace: "nowrap" }} {...props}>
      <HUText fontStyle={wholePartFontStyle ?? "DS"}>{wholePart}</HUText>
      <HUText fontStyle={decimalPartFontStyle ?? "HL"}>
        {decimalPart ? `,${decimalPart}${symbol}` : ` ${symbol}`}
      </HUText>
    </div>
  )
}
